import {
  changeUserSubscription,
  getSubscriptions,
} from 'spa/action_creators/subscriptions'
import {
  CURRENCY_SYMBOL_MAP,
  DEFAULT_SHORT_DATE_OPTION,
} from '../../shared/utils'
import { homePathSelector } from 'spa/selectors/users'
import { injectIntl } from 'react-intl'
import { Knotch } from '../knotch'
import { localizedMessages } from './localized_messages'
import { PROMOS, SUBSCRIPTIONS } from '../../shared/messages'
import { Redirect, useHistory } from 'react-router-dom'
import { Subheading, TextStyle } from '../typography'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import styles from './styles.sass'
import SubscriptionSelection from './subscription_selector'

const SubscriptionUpdate = ({ intl }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const homePath = useSelector(homePathSelector)

  const {
    currentUser: {
      user: {
        activeSubscription,
        locale,
        subscription,
        nextCycle,
        paymentProcessorFeatures,
      },
    },
    subscriptions,
  } = useSelector(state => state)
  const {
    currentPlan,
    nextPlan,
    nextPlanPrice,
    nextPlanCurrencyId,
  } = subscription

  const currentSub = currentPlan.includes('_')
    ? subscriptions.list.find(s => s.subscriptionKey === currentPlan)
    : { name: intl.formatMessage(PROMOS.ALL) }

  const canChangeSubscription = () => {
    return (
      activeSubscription &&
      paymentProcessorFeatures?.changePlan &&
      (nextPlan || currentPlan)
    )
  }
  if (!process.env.IS_TEST && !canChangeSubscription())
    return <Redirect to={homePath} />

  const [selectedSub, setSelectedSub] = useState(
    nextPlan !== 'nextplan' ? nextPlan : currentPlan
  )

  const updateSubscription = () => {
    if (nextPlan !== selectedSub) {
      dispatch(changeUserSubscription({ subscriptionKey: selectedSub }))
    }
  }

  const handleSubChange = subscriptionKey => {
    setSelectedSub(subscriptionKey)
  }

  useEffect(() => {
    if (!subscriptions.list.length) {
      dispatch(getSubscriptions())
    }
  }, [subscriptions.list])

  return (
    <div className={styles.container}>
      <div className={styles.message}>
        <Subheading color="black">
          {intl.formatMessage(localizedMessages.changeSubscription)}
        </Subheading>
      </div>
      <div className={classNames(styles.row, styles.knotches)}>
        <Knotch fat="fat" />
        <Knotch fat="fat" />
        <Knotch className={styles.lastKnotch} fat="fat" />
      </div>
      {activeSubscription && (
        <div className={styles.infoRow}>
          <div className={styles.infoBlock}>
            <TextStyle color="grey" padding="paddingTop" variant="label">
              {intl.formatMessage(localizedMessages.subscriptionInfo, {
                currentPlan:
                  currentSub?.name ||
                  intl.formatMessage(SUBSCRIPTIONS[currentPlan.split('_')[0]]),
                currentPlanPrice: currentPlan.price || '',
                currentPlanCurrency:
                  CURRENCY_SYMBOL_MAP[currentPlan.currency || 'USD'],
                nextPlan: intl.formatMessage(
                  nextPlan === 'nextplan'
                    ? SUBSCRIPTIONS[currentPlan.split('_')[0]]
                    : SUBSCRIPTIONS[nextPlan.split('_')[0]]
                ),
                nextPlanStart: new Date(nextCycle).toLocaleDateString(
                  locale,
                  DEFAULT_SHORT_DATE_OPTION
                ),
                nextPlanPrice: nextPlanPrice || '',
                nextPlanCurrency:
                  CURRENCY_SYMBOL_MAP[nextPlanCurrencyId || 'USD'],
              })}
            </TextStyle>
          </div>
        </div>
      )}
      <SubscriptionSelection
        handleSubscriptionChange={handleSubChange}
        subscriptionSelected={selectedSub}
        subscriptions={subscriptions}
      />
      <div className={styles.buttonsContainer}>
        <button
          disabled={nextPlan === selectedSub}
          onClick={updateSubscription}
        >
          {intl.formatMessage(localizedMessages.changePlan)}
        </button>
        <button className="secondary" onClick={() => history.goBack()}>
          {intl.formatMessage(localizedMessages.changeCancel)}
        </button>
      </div>
    </div>
  )
}

SubscriptionUpdate.displayName = 'SubscriptionUpdate'

SubscriptionUpdate.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func,
  }).isRequired,
}

export default injectIntl(SubscriptionUpdate)
